import { authAPI } from "../api";
import { tokenStorage } from "../lib/token-storage";

/**
 * 로그아웃 Use Case
 * API 호출 → 로컬 저장소 정리 워크플로우
 */
export class LogoutUseCase {
  async execute() {
    try {
      // API 호출 (백엔드에 로그아웃 알림)
      await authAPI.logout();
    } catch (err) {
      // 네트워크 오류 등 무시하고 진행
      console.warn("Logout API call failed:", err);
    } finally {
      // 로컬 저장소 정리 (환경변수 설정 키 사용)
      tokenStorage.clear();
    }
  }
}

export const logoutUseCase = new LogoutUseCase();
